import { render } from "./CardMenu.vue?vue&type=template&id=f81ca290"
import script from "./CardMenu.vue?vue&type=script&lang=js"
export * from "./CardMenu.vue?vue&type=script&lang=js"
script.render = render

export default script